import { useEffect, useState } from "react";
import "./ProfileDetailsForm.css";
import {
  ActionButton,
  Button,
  Container,
  Icon,
  InputField,
  InputPhoneDropdown,
  Notifications,
  Text,
} from "@jds/core";
import {
  emptyObj,
  validateEmail,
  validateNameInput,
  validateNameWithOnlyLetters,
  validatePhoneNumber,
  validateTextInput,
} from "../../../util/validation";
import useInput from "../../../hooks/use-input";
import imageUploaded, {
  addParamsURL,
  baseToImg,
  fileToBase,
} from "../../../util/helper";
import useApiHttp from "../../../hooks/use-http";
import PageLoader from "../Loader/PageLoader";
import JdsModal from "../JdsModal";
import AvatarView from "../Views/avatarView/AvatarView";
import AvatarUploadCamera from "./avatarUpload/AvatarUploadCamera";
import { useDispatch, useSelector } from "react-redux";
import decryptUrl from "../../../util/img-decryption";
import { Box, IconButton, Tooltip } from "@mui/material";
import AdditionalDetailsForm from "./AdditionalDetailsForm";
import Selfie from "../Selfie/Selfie";
import SelfieLiveliness from "../Selfie/SelfieLiveliness";
import { setSelfieModalClose } from "../../../store/state-slices/userRegistration";

export default function ProfileDetailForm(props) {
  const dispatch = useDispatch()
  const [userSelectProfile, setUserSelectProfile] = useState("");
  const [profileImgModalClose, setrofileImgModalClose] = useState(true);
  const [profileImgModalOpened, setProfileImgModalOpened] = useState(false);
  const { selfieModalClose } = useSelector((state) => state.userRegistration);
  const [profileImgFile, setProfileImgFile] = useState();
  const [profileHeader, setProfileHeader] = useState("Upload profile picture");
  const [socialLinksModalClose, setSocialLinksModalClose] = useState(true);
  const [socialMediaLinks, setSocialMediaLinks] = useState({});
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails
  );

  const isSchoolUser = profileDetailsRedux?.userType === "SCHOOL";
  console.log("Profile userType", profileDetailsRedux?.userType);

  const { sendRequest: updateProfile, isLoading: isProfileUpdating } =
    useApiHttp();

  const { sendRequest: getFaceCount, isLoading: isGetFaceCounting } =
    useApiHttp();
  const [selectedCountry, setSelectedCountry] = useState();
  const {
    value: profileImage,
    isValid: isValidProfileImage,
    hasError: profileImageError,
    valueChangeHandler: profileImageChangeHandler,
    inputBlurHandler: profileImageBlurHandler,
    reset: resetProfileImage,
  } = useInput(validateTextInput, {
    type: "text",
    value: profileDetailsRedux?.profilePictureThumbnailUrl,
  });

  const {
    value: firstName,
    isValid: isValidFirstName,
    hasError: firstNameError,
    valueChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstName,
  } = useInput(
    (input) =>
      isSchoolUser
        ? validateTextInput(input)
        : ((data) => {
          if (typeof data !== "string") return false;
          if (data.length > 20) return false;
          const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
          return pattern.test(data.trim());
        })(input),
    {
      type: "text",
      value: profileDetailsRedux?.firstName,
    }
  );
  const {
    value: lastName,
    isValid: isValidlastName,
    hasError: lastNameError,
    valueChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetLastName,
  } = useInput(
    (input) =>
      isSchoolUser
        ? validateTextInput(input)
        : ((data) => {
          if (typeof data !== "string") return false;
          if (data.length > 20) return false;
          const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
          return pattern.test(data.trim());
        })(input),
    {
      type: "text",
      value: profileDetailsRedux?.lastName,
    }
  );
  const {
    value: phoneNumber,
    isValid: isValidPhoneNumber,
    hasError: phoneNumberError,
    valueChangeHandler: phoneNumberChangeHandler,
    inputBlurHandler: phoneNumberBlurHandler,
    reset: resetPhoneNumber,
  } = useInput(validatePhoneNumber, {
    type: "text",
    value: profileDetailsRedux?.phoneNumber,
  });
  const {
    value: emailAddress,
    isValid: isValidEmailAddress,
    hasError: emailAddressError,
    valueChangeHandler: emailAddressChangeHandler,
    inputBlurHandler: emailAddressBlurHandler,
    reset: resetEmailAddress,
  } = useInput(validateEmail, {
    type: "text",
    value: profileDetailsRedux?.email,
  });

  // const isValidForm =
  //   !isValidFirstName ||
  //   !isValidlastName ||
  //   !isValidEmailAddress ||
  //   !isValidPhoneNumber ||
  //   !isValidProfileImage;

  const isValidForm = !isValidFirstName || !isValidlastName || !profileImage;
  // (!isValidEmailAddress ||
  //   emailAddress !== undefined ||
  //   emailAddress !== null);

  const handleSubmit = () => {
    const countryCode = countryCodeItems.filter((items, index) => {
      if (index == selectedCountry) {
        return items;
      }
    })[0]?.value;
    if (profileImgFile) {
      console.log("hello profile");

      const userProfile = new FormData();
      // userProfile.append("email", emailAddress || null);
      if (profileDetailsRedux?.firstName !== firstName) {
        userProfile.append("firstName", firstName.trim());
      }
      if (profileDetailsRedux?.lastName !== lastName) {
        userProfile.append("lastName", lastName.trim());
      }
      userProfile.append("profilePicture", profileImgFile);
      console.log(profileImgFile);
      let socialObj = {
        facebook: null,
        instagram: null,
        youtube: null,
        email: null,
        website: null,
        mobile: null,
      };
      // userProfile.append(
      //   "metadata",
      //   JSON.stringify({ ...socialObj, ...socialMediaLinks })
      // );
      updateProfile(
        {
          base: "AUTH",
          url: `profile`,
          method: "PUT",
          body: userProfile,
          formData: true,
        },
        null,
        (data) => {
          Notifications.toast.success({
            id: "update-profile",
            title: data?.message,
          });
          console.log("hello1234profile");
          props?.updateProfile();
          props?.closeModal();
        },
        (err, data) => {
          Notifications.toast.error({
            id: "update-profile",
            title: data?.message,
          });
        }
      );
    } else {
      const userProfile = new FormData();
      // userProfile.append("email", emailAddress || null);
      if (profileDetailsRedux?.firstName !== firstName) {
        userProfile.append("firstName", firstName.trim());
      }
      if (profileDetailsRedux?.lastName !== lastName) {
        userProfile.append("lastName", lastName.trim());
      }
      let socialObj = {
        facebook: null,
        instagram: null,
        youtube: null,
        email: null,
        website: null,
        mobile: null,
      };
      // userProfile.append(
      //   "metadata",
      //   JSON.stringify({ ...socialObj, ...socialMediaLinks })
      // );
      updateProfile(
        {
          base: "AUTH",
          url: `profile`,
          method: "PUT",
          body: userProfile,
          formData: true,
        },
        null,
        (data) => {
          Notifications.toast.success({
            id: "update-profile",
            title: data?.message,
          });
          console.log("hello1234profile");
          props?.updateProfile();
          props?.closeModal();
        },
        (err, data) => {
          Notifications.toast.error({
            id: "update-profile",
            title: data?.message,
          });
        }
      );
    }
    // resetFirstName();
    // resetLastName();
    // resetPhoneNumber();
    // resetEmailAddress();
    // resetProfileImage();
  };

  const countryCodeItems = [
    {
      label: "+88",
      prefix: <Icon ic={"IcAdd"} />,
      value: "+88",
    },
    {
      label: "+78",
      prefix: <Icon ic={"IcAdd"} />,
      value: "+78",
    },
    {
      label: "+91",
      prefix: <Icon ic={"IcAdd"} />,
      value: "+91",
    },
  ];
  const socialLinkIcon = {
    facebook: {
      id: "icFb",
      icon: "IcFacebook",
      type: "link",
    },
    instagram: {
      id: "icIg",
      icon: "IcInstagram",
      type: "link",
    },
    youtube: {
      id: "icYt",
      icon: "IcYoutube",
      type: "link",
    },
    email: {
      id: "icMail",
      icon: "IcMail",
      type: "email",
    },
    website: {
      id: "icGlobe",
      icon: "IcGlobe",
      type: "link",
    },
    mobile: {
      id: "icPhone",
      icon: "IcCall",
      type: "mobile",
    },
  };

  let selectedCountryLabel = countryCodeItems[selectedCountry || 0]?.label;
  const [countryCodeUpdate, setCountryCodeUpdate] = useState(false);
  useEffect(() => {
    countryCodeItems.filter((item, index) => {
      if (item.value === profileDetailsRedux?.countryCode) {
        setSelectedCountry(index);
        setCountryCodeUpdate(true);
      }
    });
    let socialObj = profileDetailsRedux?.metadata || {};
    let socialObjValid = Object.fromEntries(
      Object.entries(socialObj).filter(
        ([key, value]) => value !== null && value !== ""
      )
    );
    setSocialMediaLinks(socialObjValid);
  }, []);

  return (
    <>
      <div action="" className="column-form">
        <div style={{ textAlign: "center" }}>
          <Container
            fullWidth
            horizontalAlign="center"
            style={{ marginBottom: "12px" }}
          >
            <Text text="Upload Image *" color="primary-grey-80" />
          </Container>
          <AvatarView
            image={
              userSelectProfile
                ? baseToImg(userSelectProfile)
                : addParamsURL(
                  profileDetailsRedux?.profilePictureThumbnailUrl,
                  {
                    size: "m",
                  }
                )
                  ? // ? decryptUrl(profileDetailsRedux?.profilePictureThumbnailUrl)
                  addParamsURL(
                    profileDetailsRedux?.profilePictureThumbnailUrl,
                    {
                      size: "m",
                    }
                  )
                  : ""
            }
            onClick={() => {
              dispatch(setSelfieModalClose(false));
            }}
          />
          {profileImgModalOpened && !profileImage && (
            <>
              {" "}
              <Container
                fullWidth
                horizontalAlign="center"
                verticalAlign="center"
                style={{ marginTop: "12px", gap: "8px" }}
              >
                <Icon ic={"IcErrorColored"} size={"small"} />
                <Text
                  text="Please upload a valid image!"
                  color="feedback-error-80"
                  appearance="body-xs"
                />
              </Container>
            </>
          )}
        </div>

        {isSchoolUser ? (
          <JdsModal
            header={profileHeader}
            size="m"
            close={profileImgModalClose}
            onClose={() => {
              setrofileImgModalClose(true);
              setProfileImgModalOpened(true);
            }}
          >
            {!profileImgModalClose && (
              <AvatarUploadCamera
                image={
                  userSelectProfile
                    ? baseToImg(userSelectProfile)
                    : profileDetailsRedux?.profilePictureThumbnailUrl
                      ? // ? decryptUrl(profileDetailsRedux?.profilePictureThumbnailUrl)
                      addParamsURL(
                        profileDetailsRedux?.profilePictureThumbnailUrl,
                        {
                          size: "m",
                        }
                      )
                      : ""
                }
                accept=".png ,.jpg ,.jpeg"
                fileValue={(file) => {
                  setProfileImgFile(file);
                  fileToBase(file)
                    .then((base64Value) => {
                      setUserSelectProfile(base64Value);
                      profileImageChangeHandler({
                        target: { value: base64Value },
                      });
                    })
                    .catch((error) => { });
                }}
                setProfileHeader={(e) => setProfileHeader(e)}
              />
            )}
          </JdsModal>
        ) : (
          <JdsModal
            kind={"custom"}
            header="Profile picture"
            headerProps={{
              divider: "false",
            }}
            size="m"
            close={selfieModalClose}
            onClose={() => {
              dispatch(setSelfieModalClose(true));
              setProfileImgModalOpened(true);
            }}
          >
            {!selfieModalClose &&
              <SelfieLiveliness
                isGetFile={true}
                getFile={(file) => {
                  setProfileImgFile(file);
                  fileToBase(file)
                    .then((base64Value) => {
                      setUserSelectProfile(base64Value);
                      profileImageChangeHandler({
                        target: { value: base64Value },
                      });
                    })
                    .catch((error) => { });
                  dispatch(setSelfieModalClose(true));
                  setProfileImgModalOpened(true);
                }}
              />}
            {/* <Selfie
                isGetFile={true}
                getFile={(file) => {
                  setProfileImgFile(file);
                  fileToBase(file)
                    .then((base64Value) => {
                      setUserSelectProfile(base64Value);
                      profileImageChangeHandler({
                        target: { value: base64Value },
                      });
                    })
                    .catch((error) => {});
                  setrofileImgModalClose(true);
                  setProfileImgModalOpened(true);
                }}
              /> */}
          </JdsModal>
        )}

        {
          <>
            <InputField
              label={`${isSchoolUser ? "School" : ""} First Name`}
              value={firstName}
              name="firstName"
              onChange={(e) => {
                firstNameChangeHandler(e, e.target.value);
              }}
              onBlur={firstNameBlurHandler}
              state={firstNameError ? "error" : ""}
              stateText={
                !isSchoolUser
                  ? firstName?.length > 20
                    ? "The First name length can't exceed 20 characters"
                    : firstName?.length == 0
                      ? "The First name can't be blank"
                      : "The First name can't contain spaces, special characters and numbers"
                  : "School first name should not be empty"
              }
              required
            />
            <InputField
              label={`${isSchoolUser ? "School" : ""} Last Name`}
              value={lastName}
              name="lastName"
              onChange={(e) => {
                lastNameChangeHandler(e, e.target.value);
              }}
              onBlur={lastNameBlurHandler}
              state={lastNameError ? "error" : ""}
              stateText={
                !isSchoolUser
                  ? lastName?.length > 20
                    ? "The Last name length can't exceed 20 characters"
                    : lastName?.length == 0
                      ? "The Last name can't be blank"
                      : "The Last name can't contain spaces, special characters and numbers"
                  : "School Last name should not be empty"
              }
              required
            />
          </>
        }

        {/* {isSchoolUser &&
          <Box position="relative">
            <InputField
              label="School Name *"
              value={firstName}
              name="schoolName"
              onChange={firstNameChangeHandler}
              onBlur={firstNameBlurHandler}
              state={firstNameError ? "error" : ""}
              stateText={
                "School name should not be empty."
              }
              suffix={<Text text="Schoool" />}
              required
            />
            {firstName &&
              <Box position="absolute" sx={{ right: 0, top: `${firstNameError ? '25%' : '34%'}`, padding: '4px', backgroundColor: 'white' }}>
                <Text text="School" appearance="body-xs" color="primary-grey-80" />
              </Box>
            }
          </Box>
        } */}

        {/* <InputField
        label="Phone Number"
        value={phoneNumber}
        name="phoneNumber"
        onChange={phoneNumberChangeHandler}
        onBlur={phoneNumberBlurHandler}
        state={phoneNumberError ? "error" : ""}
        stateText="phone number is invalid"
      /> */}

        {/* <InputField
          label="Phone Number"
          value={phoneNumber}
          name="phoneNumber"
          onChange={phoneNumberChangeHandler}
          onBlur={phoneNumberBlurHandler}
          state={phoneNumberError ? "error" : ""}
          stateText="Please enter a valid number!"
          type="number"
          disabled
          prefix={
            countryCodeUpdate ? (
              <InputPhoneDropdown
                selectedIndex={selectedCountry}
                items={countryCodeItems}
                countryCode={selectedCountryLabel}
                onSelect={(idx) => {
                  setSelectedCountry(idx);
                }}
              />
            ) : (
              ""
            )
          }
        /> */}

        {/* <InputField
          label="Email*"
          value={emailAddress}
          name="emailAddress"
          onChange={emailAddressChangeHandler}
          onBlur={emailAddressBlurHandler}
          state={emailAddressError ? "error" : ""}
          stateText="Please enter a valid email id!"
        /> */}
        {/* {Object.keys(socialMediaLinks).length > 0 && (
          <Box mt={1}>
            <div className="social-links">
              <Text text={"Additional Details"} appearance={"body-m-bold"} />
              <Button
                label="Edit"
                kind="secondary"
                size="small"
                onClick={() => setSocialLinksModalClose(false)}
              />
            </div>
            <Container fullWidth direction="column" gap={8}>
              {Object.entries(socialMediaLinks).map(([key, value], i) => (
                <Tooltip
                  key={i}
                  title={value.length > 30 ? <Text text={value} /> : ""}
                  placement="top-end"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "none",
                      },
                    },
                  }}
                >
                  <Box
                    gap={1}
                    sx={{
                      display: "flex",
                      width: "100%",
                      "& .text-atom": {
                        width: "450px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      },
                    }}
                  >
                    <Icon ic={socialLinkIcon[key]?.icon} />
                    <Text className="name-overflow" key={key} text={value} />
                  </Box>
                </Tooltip>
              ))}
            </Container>
          </Box>
        )} */}
        {/* {Object.keys(socialMediaLinks).length == 0 && (
          <Box
            mt={1}
            sx={{ cursor: "pointer" }}
            // onClick={() => setSocialLinksModalClose(false)}
            onClick={() => {
              console.log(socialMediaLinks);
              setSocialLinksModalClose(false);
            }}
          >
            <Text
              text="Add more details"
              color="primary_60"
              appearance="body-s-bold"
            />
          </Box>
        )} */}
        <Container
          fullWidth
          horizontalAlign="center"
          style={{ marginTop: "24px", width: "200px", margin: "auto" }}
        >
          <Button
            disabled={isValidForm}
            type="submit"
            fullWidth
            label={isProfileUpdating ? "Saving" : "Save"}
            size="large"
            onClick={() => {
              handleSubmit();
            }}
            loading={isProfileUpdating}
          />
        </Container>
      </div>
      <JdsModal
        header="Additonal Details"
        close={socialLinksModalClose}
        onClose={() => {
          setSocialLinksModalClose(true);
        }}
        size="m"
      >
        <Box sx={{ p: "12px 24px" }}>
          <AdditionalDetailsForm
            onCancel={() => setSocialLinksModalClose(true)}
            setSocialMediaLinks={setSocialMediaLinks}
            socialMediaLinks={socialMediaLinks}
            socialLinkIcon={socialLinkIcon}
          />
        </Box>
      </JdsModal>
      {isProfileUpdating ||
        (isGetFaceCounting && (
          <PageLoader open={isProfileUpdating || isGetFaceCounting} />
        ))}
    </>
  );
}
